import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_1209355728 from "../../../../../packages/component/src/components/form/demo/demo1.js?loadDemo";
import legacyImportDemo_2612232499 from "../../../../../packages/component/src/components/form/demo/demo2.js?loadDemo";
import legacyImportDemo_4260492900 from "../../../../../packages/component/src/components/form/demo/demo14.js?loadDemo";
import legacyImportDemo_2488780562 from "../../../../../packages/component/src/components/form/demo/demo3.js?loadDemo";
import legacyImportDemo_42794101 from "../../../../../packages/component/src/components/form/demo/demo4.js?loadDemo";
import legacyImportDemo_60789588 from "../../../../../packages/component/src/components/form/demo/demo5.js?loadDemo";
import legacyImportDemo_2785696951 from "../../../../../packages/component/src/components/form/demo/demo6.js?loadDemo";
import legacyImportDemo_469458582 from "../../../../../packages/component/src/components/form/demo/demo7.js?loadDemo";
import legacyImportDemo_306125305 from "../../../../../packages/component/src/components/form/demo/demo8.js?loadDemo";
import legacyImportDemo_3061745368 from "../../../../../packages/component/src/components/form/demo/demo9.js?loadDemo";
import legacyImportDemo_4197428069 from "../../../../../packages/component/src/components/form/demo/demo15.js?loadDemo";
import legacyImportDemo_1749461856 from "../../../../../packages/component/src/components/form/demo/demo10.js?loadDemo";
import legacyImportDemo_170834280 from "../../../../../packages/component/src/components/form/demo/demo18.js?loadDemo";
import legacyImportDemo_3426229865 from "../../../../../packages/component/src/components/form/demo/demo19.js?loadDemo";
import legacyImportDemo_1162818657 from "../../../../../packages/component/src/components/form/demo/demo11.js?loadDemo";
import legacyImportDemo_188169826 from "../../../../../packages/component/src/components/form/demo/demo12.js?loadDemo";
import legacyImportDemo_229155939 from "../../../../../packages/component/src/components/form/demo/demo13.js?loadDemo";
import legacyImportDemo_4254978918 from "../../../../../packages/component/src/components/form/demo/demo16.js?loadDemo";
import legacyImportDemo_4220258663 from "../../../../../packages/component/src/components/form/demo/demo17.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_1209355728,
  legacyImportDemo_2612232499,
  legacyImportDemo_4260492900,
  legacyImportDemo_2488780562,
  legacyImportDemo_42794101,
  legacyImportDemo_60789588,
  legacyImportDemo_2785696951,
  legacyImportDemo_469458582,
  legacyImportDemo_306125305,
  legacyImportDemo_3061745368,
  legacyImportDemo_4197428069,
  legacyImportDemo_1749461856,
  legacyImportDemo_170834280,
  legacyImportDemo_3426229865,
  legacyImportDemo_1162818657,
  legacyImportDemo_188169826,
  legacyImportDemo_229155939,
  legacyImportDemo_4254978918,
  legacyImportDemo_4220258663,
  React
};